import { BannerSvg } from "../assets";
import { BulletWrapper } from "../components/Home";
import { ButtonLink } from "../components/Button";
import {
  SubtitleWrapper,
  TextShadeWrapper,
  TitleWrapper,
} from "../components/Wrappers";
import { AMAZON_STORE_LINK, AUTHOR_PROFILE_LINK } from "../constants";

const Home = () => {
  return (
    <div className="homepage">
      <div className="homepage__content">
        <BulletWrapper className="homepage__subtitle">
          Blockchain Banking
        </BulletWrapper>
        <TitleWrapper
          fontSize="52px"
          fontSizeSm="34px"
          marginTop="17px"
          marginBottom="20px"
          maxWidth="710px"
          maxWidthMd="100%"
          textAlignMd="center"
          textAlignSm="left"
        >
          Blockchain is to the Money what{" "}
          <TextShadeWrapper> Email was to the Letter</TextShadeWrapper>
        </TitleWrapper>
        <BulletWrapper className="homepage__author">
          by <span>Monty C. M. Metzger, 2023</span>
        </BulletWrapper>
        <SubtitleWrapper
          fontSize="22px"
          lineHeight="34px"
          marginTop="33px"
          marginTopSm="26px"
          marginBottom="50px"
          marginBottomSm="20px"
          maxWidth="565px"
          maxWidthMd="100%"
          textAlignMd="center"
          textAlignSm="left"
        >
          With the rise of the internet and mobile technology, communication,
          information access, and business have changed rapidly. This book
          covers blockchain, digital assets, and the internet of value. This
          technology could potentially transform how we think about money,
          finance, and value, and its impacts on society, business, and
          governments will be explored.
        </SubtitleWrapper>
        <div className="homepage__btns">
          <ButtonLink primaryBtn href={AMAZON_STORE_LINK} widthSm="100%">
            Get your Copy
          </ButtonLink>
          <ButtonLink secondaryBtn href={AUTHOR_PROFILE_LINK} widthSm="100%">
            About the Author
          </ButtonLink>
        </div>
      </div>
      <div className="homepage__banner">
        <img src={BannerSvg} alt="banner" />
      </div>
    </div>
  );
};

export default Home;
